"use strict";
function identity(x) {
    return x;
}
exports.identity = identity;
//# sourceMappingURL=identity.js.map


//////////////////
// WEBPACK FOOTER
// /data/wwwroot/xzhipin/app-client/node_modules/rxjs/util/identity.js
// module id = ../../../../rxjs/util/identity.js
// module chunks = vendor